import { useState } from 'react'
import { EditButton } from '../EditButton'
import { ClientMainInfoPopup } from '../Popups/ClientMainInfoPopup'
import { IClient, IClientCreate } from 'src/utils/Interfaces/client.interface'
import { useUpdateClientMutation } from 'src/redux/Api/clientsApi'

export const EditClientMainInfo = ({ data }: { data: IClient }) => {
  const [isEdit, setIsEdit] = useState(false)
  const [updateClient] = useUpdateClientMutation()
  const { id, ...restData } = data;

  const handleClientMainInfo = async (value: Partial<IClientCreate>) => {
    try {
      await updateClient({ id: data.id.toString(), body: {...restData, ...value} })
      setIsEdit(false)
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <>
      <EditButton onClick={() => setIsEdit(true)} />
      {isEdit && <ClientMainInfoPopup defaultData={data} handleClientMainInfo={handleClientMainInfo} setClientMainInfoPopup={() => setIsEdit(false)} />}
    </>
  )
}
